import { Badge, Form } from "react-bootstrap";
import VerifiedSignature from "../../../../../img/documentsign.png";
import { studySubjectPrincipleInvestigatorServices } from "../../../../../APIServices/studySubjectPrincipleInvestigatorServices";
import { useEffect, useState } from "react";
import Moment from "react-moment";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";

const InvestigatorSignature = ({
  studyId,
  siteId,
  subjectId,
  StudyMode,
}) => {
  const [loading, setLoading] = useState(false);
  const [signatureList, setSignatureList] = useState([]);
  const [correctionSignatureList, setcorrectionSignatureList] = useState([]);

  const getSingleSubjectPrincipleInvestigator = async () => {
    setLoading(true);
    let data = await studySubjectPrincipleInvestigatorServices.getSingleSubjectPrincipleInvestigator(
      studyId,
      siteId,
      subjectId,
      StudyMode,
    )

    setSignatureList(data?.statementSign || []);
    setcorrectionSignatureList(data?.correctionSign || []);
    setLoading(false);
  }

  useEffect(() => {
    getSingleSubjectPrincipleInvestigator();
  }, [
    studyId,
    siteId,
    subjectId,
    StudyMode,
  ]);


  const getGMTOffset = () => {
    const offsetMinutes = new Date().getTimezoneOffset();
    const sign = offsetMinutes <= 0 ? "+" : "-";
    const absMinutes = Math.abs(offsetMinutes);
    const hours = String(Math.floor(absMinutes / 60)).padStart(2, "0");
    const minutes = String(absMinutes % 60).padStart(2, "0");
    return `GMT${sign}${hours}:${minutes}`;
  };

  return (
    <>
      {loading ? (
        <PageLoader />
      ) : signatureList?.length === 0 ? (
        <div className="hstack justify-content-center h-100">
          <NoDataFoundTable MSG={"No any Signature!."} />
        </div>
      ) : (
        <>
          <div className="p-4">
            <div className="bg-light border rounded p-2 position-relative">
              <Badge
                className="position-absolute text-muted bg-success-subtle br3"
                style={{ top: -10, left: 20 }}
              >
                STATEMENT
              </Badge>
              <div className="p-3">
                <Form.Group className="mb-2 text-center">
                  <Form.Label className="fw-bold mb-1" style={{ fontSize: 18 }}>
                    INVESTIGATOR SIGNATURE
                  </Form.Label>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label>
                    Investigator’s signature on this section indicates that he/she
                    has reviewed the corrected/additional data associated with the
                    case report forms for this subject and have determined that the
                    data are accurate and are consistent with supporting source
                    documentation.
                  </Form.Label>
                </Form.Group>
                {signatureList?.map((item, index) => (
                  <div key={index} className="hstack justify-content-end">
                    <div className="p-3">
                      <div
                        className="border border-2 rounded-start border-success border-end-0 position-relative"
                        style={{ maxWidth: "fit-content" }}
                      >
                        <div className="p-3">
                          <div className="hstack gap-2">
                            <h6 className="m-0 fw-bold">
                              {item?.assignedToFirstName}
                              <br />
                              {item?.assignedToLastName}
                            </h6>
                            <div>
                              <p className="m-0" style={{ fontSize: 9 }}>
                                Digitally signed by
                                <br />
                                {item?.assignedToName}
                              </p>
                              <p className="m-0" style={{ fontSize: 9 }}>
                                Date:{" "}
                                <Moment format="DD/MM/YYYY" withTitle>
                                  {item?.completedDT}
                                </Moment>{" "}
                                <br />
                                <Moment format="HH:mm:ss" withTitle>
                                  {item?.completedDT}
                                </Moment>{" "}
                                {getGMTOffset() || "NA"}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          className="position-absolute bg-light w-100"
                          style={{ top: -10, left: 30 }}
                        >
                          <p className="fw-bold m-0 ps-1 fontSize12">eSigned By:</p>
                        </div>
                        <div
                          className="position-absolute bg-light w-100"
                          style={{ bottom: -10, left: 30 }}
                        >
                          <p className="fw-bold m-0 ps-1 fontSize12">
                            {item?.signatureHash}
                          </p>
                        </div>
                        <img
                          className="position-absolute"
                          style={{
                            top: 8,
                            left: 47,
                            pointerEvents: "none",
                            filter: "opacity(0.2)",
                            width: 70,
                          }}
                          src={VerifiedSignature}
                          alt="Signed"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="p-4">
            {correctionSignatureList?.map((element, index) => (
              <div className="bg-light border rounded p-2 position-relative mb-4">
                <Badge
                  className="position-absolute text-muted bg-success-subtle br3"
                  style={{ top: -10, left: 20 }}
                >
                  {index + 1}. CORRECTION/ADDITION
                </Badge>
                <div className="p-3">
                  <Form.Label className="fw-bold m-0" style={{ fontSize: 15 }}>
                    DATA CORRECTION/ADDITION IN CASE REPORT FORM.
                  </Form.Label>
                  <Form.Group className="mb-2">
                    <Form.Label>
                      Data correction or addition in the Case Report Form after
                      previous signature.
                    </Form.Label>
                  </Form.Group>
                  {(element?.data || [])?.map((item, index) => (
                    <div key={index} className="hstack justify-content-end">
                      <div className="p-3">
                        <div
                          className="border border-2 rounded-start border-success border-end-0 position-relative"
                          style={{ maxWidth: "fit-content" }}
                        >
                          <div className="p-3">
                            <div className="hstack gap-2">
                              <h6 className="m-0 fw-bold">
                                {item?.assignedToFirstName}
                                <br />
                                {item?.assignedToLastName}
                              </h6>
                              <div>
                                <p className="m-0" style={{ fontSize: 9 }}>
                                  Digitally signed by
                                  <br />
                                  {item?.assignedToName}
                                </p>
                                <p className="m-0" style={{ fontSize: 9 }}>
                                  Date:{" "}
                                  <Moment format="DD/MM/YYYY" withTitle>
                                    {item?.completedDT}
                                  </Moment>{" "}
                                  <br />
                                  <Moment format="HH:mm:ss" withTitle>
                                    {item?.completedDT}
                                  </Moment>{" "}
                                  {getGMTOffset() || "NA"}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="position-absolute bg-light w-100"
                            style={{ top: -10, left: 30 }}
                          >
                            <p className="fw-bold m-0 ps-1 fontSize12">eSigned By:</p>
                          </div>
                          <div
                            className="position-absolute bg-light w-100"
                            style={{ bottom: -10, left: 30 }}
                          >
                            <p className="fw-bold m-0 ps-1 fontSize12">
                              {item?.signatureHash}
                            </p>
                          </div>
                          <img
                            className="position-absolute"
                            style={{
                              top: 8,
                              left: 47,
                              pointerEvents: "none",
                              filter: "opacity(0.2)",
                              width: 70,
                            }}
                            src={VerifiedSignature}
                            alt="Signed"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default InvestigatorSignature;
